export const Types = {
  SET_PAGE: "pages/SET_PAGE",
  CLOSE_PAGE: "pages/CLOSE_PAGE"
};

const INITIAL_STATE = {
  currentPageName: "",
  currentPagePath: "",
  openedPages: []
};

export default function pages(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SET_PAGE:
      if (state.openedPages.find(page => page.name === action.payload.name)) {
        return {
          ...state,
          currentPageName: action.payload.name,
          currentPagePath: action.payload.path
        };
      } else {
        return {
          ...state,
          currentPageName: action.payload.name,
          currentPagePath: action.payload.path,
          openedPages: [
            ...state.openedPages,
            { name: action.payload.name, path: action.payload.path }
          ]
        };
      }
    case Types.CLOSE_PAGE:
      return {
        ...state,
        openedPages: action.payload.pages
      };
    default:
      return state;
  }
}

export const Creators = {
  setPage: (name, path) => ({
    type: Types.SET_PAGE,
    payload: { name, path }
  }),
  closePage: pages => ({
    type: Types.CLOSE_PAGE,
    payload: { pages }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/pages.js